import React, { useRef } from "react";
import InputBoxes from "../common/InputBoxes";
import { checkChildrenAndSetFocus } from "../common/interactiveCommon";

const KS2Address = (props) => {
  const { streetNumber, streetAddress, subUrb, town, postCode, setAddressData } = props;
  const streetAddressDivRef = useRef(null);
  const streetNumberDivRef = useRef(null);
  const subUrbDivRef = useRef(null);
  const townDivRef = useRef(null);
  const postCodeDivRef = useRef(null);

  const onTextChange = (e) => {
    const { name, value } = e.target;
    const index = name
      .replace("streetAddress", "")
      .replace("streetNumber", "")
      .replace("subUrb", "")
      .replace("town", "")
      .replace("postCode", "");
    if (name.indexOf("streetAddress") >= 0) {
      checkChildrenAndSetFocus(streetAddressDivRef.current.children, index);
    }
    if (name.indexOf("streetNumber") >= 0) {
      checkChildrenAndSetFocus(streetNumberDivRef.current.children, index);
    }
    if (name.indexOf("subUrb") >= 0) {
      checkChildrenAndSetFocus(subUrbDivRef.current.children, index);
    }
    if (name.indexOf("town") >= 0) {
      checkChildrenAndSetFocus(townDivRef.current.children, index);
    }
    if (name.indexOf("postCode") >= 0) {
      checkChildrenAndSetFocus(postCodeDivRef.current.children, index);
    }
    setAddressData({ name, value });
  };

  return (
    <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-12 mb-3 section-number-box">
        <div className="mb-3 number">5.</div>
        <div className="details">
          <div className="form-group form-inline">
            <div className="col-md-2 section-label">
              <label className="">Your postal address</label>
            </div>

            <div className="col-md-10">
              <div className="row">
                <div className="col-md-3 section-form-group-inline" ref={streetNumberDivRef}>
                  <InputBoxes keyName={"streetNumber"} name={streetNumber} count={6} onTextChange={onTextChange} />
                  <small className="small-title-label d-flex small-label">Street number</small>
                </div>

                <div className="col-md-9 section-form-group-inline" ref={streetAddressDivRef}>
                  <InputBoxes keyName={"streetAddress"} name={streetAddress} count={24} onTextChange={onTextChange} />
                  <small className="small-title-label d-flex small-label">Street address or PO Box number</small>
                </div>
              </div>

              <div className="section-form-group-inline" ref={subUrbDivRef}>
                <InputBoxes keyName={"subUrb"} name={subUrb} count={15} onTextChange={onTextChange} />
                <small className="small-title-label d-flex small-label">Suburb, box lobby or RD</small>
              </div>
              <div className="row">
                <div className="col-md-6 section-form-group-inline " ref={townDivRef}>
                  <InputBoxes keyName={"town"} name={town} count={15} onTextChange={onTextChange} />
                  <small className="small-title-label d-flex small-label">Town or city</small>
                </div>

                <div className="col-md-4 section-form-group-inline" ref={postCodeDivRef}>
                  <InputBoxes keyName={"postCode"} name={postCode} count={4} onTextChange={onTextChange} />
                  <small className="small-title-label d-flex small-label">Postcode</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KS2Address;
